import { Col, Row, Table } from 'react-bootstrap';
import { getBoolean } from './renderers';
import { IDonorRegistration } from '@nkr/models/index';
import { cardBodyStyle, cardBodyTitleStyle, cardStyle, cardBodyTitleTextStyle } from '../../styles';

interface IProps {
    data: IDonorRegistration
}

const HistoryMisc = (props: IProps) => {
    return (
        <div id='history-misc' style={cardStyle}>
            <div style={cardBodyStyle}>
                <div style={cardBodyTitleStyle}>
                    <span style={cardBodyTitleTextStyle}>History Misc</span>
                </div>
                <Row className='row-underlined row-value-center'>
                    <Col xs={6} sm={8} className='item-label'>Has Allergies?</Col>
                    <Col xs={6} sm={4}>{getBoolean(props.data.hasAllergies)}</Col>
                </Row>

                {props.data.hasAllergies && (
                    <>
                        <Row className='row-underlined'>
                            <Col xs={12}>
                                <Table striped className='table table-striped nkr-data-table'>
                                    <thead>
                                        <tr>
                                            <th>Allergy</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {props.data.allergies && props.data.allergies.map(allergy =>
                                            <tr key={allergy}>
                                                <td>{allergy}</td>
                                            </tr>
                                        )}
                                    </tbody>
                                </Table>
                            </Col>
                        </Row>
                    </>
                )}

                <Row className='row-underlined row-value-center'>
                    <Col xs={6} sm={8} className='item-label'>Has had Surgeries?</Col>
                    <Col xs={6} sm={4}>{getBoolean(props.data.hasHadSurgeries)}</Col>
                </Row>

                {props.data.hasHadSurgeries && props.data.surgeries && (
                    <>
                        <Row className='row-underlined'>
                            <Col xs={12}>
                                <Table striped className='table table-striped nkr-data-table'>
                                    <thead>
                                        <tr>
                                            <th>Surgery</th>
                                            <th>When</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {props.data.surgeries && (
                                            props.data.surgeries.map(surgery => (
                                                <tr key={surgery.name}>
                                                    <td>{surgery.name}</td>
                                                    <td>{surgery.when}</td>
                                                </tr>
                                            )))
                                        }
                                    </tbody>
                                </Table>
                            </Col>
                        </Row>
                    </>
                )}

                <Row className='row-underlined row-value-center'>
                    <Col xs={6} sm={8} className='item-label'>Takes Medication?</Col>
                    <Col xs={6} sm={4}>{getBoolean(props.data.takesMedication)}</Col>
                </Row>

                {props.data.takesMedication && (
                    <>
                        <Row className='row-underlined'>
                            <Col xs={12}>
                                <Table striped className='table table-striped nkr-data-table'>
                                    <thead>
                                        <tr>
                                            <th>Medication</th>
                                            <th>Dose</th>
                                            <th>Frequency</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {props.data.medicines && (
                                            props.data.medicines.map(med => (
                                                <tr key={med.name}>
                                                    <td>{med.name}</td>
                                                    <td>{med.dose}</td>
                                                    <td>{med.frequency}</td>
                                                </tr>
                                            )))
                                        }
                                    </tbody>
                                </Table>
                            </Col>
                        </Row>
                    </>
                )}
            </div>
        </div>
    );
}

export default HistoryMisc;